// extracted by mini-css-extract-plugin
export default {"container":"DataItem_container__Q-DFZ","label":"DataItem_label__wu7Lp","value":"DataItem_value__liCUA"};